import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import FindingsList from './FindingsList';
import { listAllFindings } from '../../../services/securityhubApi';

// Macie findings. Reuse the unified findings source scoped to the macie engine
// (the normalized shape FindingsList expects, tagged engine='macie' so a row
// click opens the Macie detail drawer); FindingDetail then fetches the raw Macie
// payload and renders the AWS-console-style MacieDetailBody.
const macieSource = (filters) => listAllFindings({ ...filters, engine: ['macie'] });

const MACIE_COLOR = '#0d9488';

export default function MacieFindings() {
  return (
    <FindingsList
      source={macieSource}
      engineKind="macie"
      subtitle="Macie findings"
      color={MACIE_COLOR}
      icon={<FindInPageOutlinedIcon sx={{ fontSize: 24 }} />}
    />
  );
}
